import RentalscapeLogo from '@/../favicon-apple-touch-144.png';
import { Placeholder } from 'rsuite';
import {
  StyledRentalscapeLogo,
  TopHalf,
  VerticalNav,
  Wrapper,
} from '../vertical-bar-styles';

export const VerticalBarSkeleton = () => {
  return (
    <Wrapper className="hidden-on-print">
      <TopHalf>
        <StyledRentalscapeLogo data-cy="deckard-vertical-bar-logo">
          <img src={RentalscapeLogo} data-cy="deckard-vertical-bar-logo" />
        </StyledRentalscapeLogo>
        <VerticalNav>
          {[...Array(6)].map((_, index) => (
            <Placeholder.Graph
              key={index}
              height={50}
              width={50}
              active
              style={{
                marginBottom: 16,
                borderRadius: 10,
                backgroundColor: '#f0f0f0',
              }}
            />
          ))}
        </VerticalNav>
      </TopHalf>
    </Wrapper>
  );
};
